import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface StatBlockProps {
  value: ReactNode;
  label: ReactNode;
  dateline?: ReactNode;
  align?: "left" | "center";
  className?: string;
}

export const StatBlock = forwardRef<HTMLDivElement, StatBlockProps>(function StatBlock(
  { value, label, dateline, align = "left", className },
  ref,
) {
  return (
    <div ref={ref} className={cn("flex flex-col gap-1", align === "center" && "items-center text-center", className)}>
      {dateline && <span className="dateline">{dateline}</span>}
      <span className="text-display text-[clamp(2rem,4vw,3.5rem)] leading-none">{value}</span>
      <span className="text-sm font-medium text-muted-foreground">{label}</span>
    </div>
  );
});
